import React from 'react';

import NotiBanner from '../components/NotiBanner';
import { connect } from 'react-redux';
import bdAuth from '../network/bdAuth';

export class App extends React.Component {

  constructor() {
    super();

    this.state = {
      user: bdAuth.getUser() || {},
      loading: true,
      submitting: false,
      showArtworkNotAvailableModal: false,
      showSubscribeModal: false,
      showNoticeBar: true
    };

  }

  render() {
    return (
      <div className="full-size" onKeyUp={this.handleEvent}>
        {this.state.showNoticeBar ? <NotiBanner /> : null}
        {
          this.props.children
        }
      </div>
    );
  }
}

export default connect((state) => {
  const { history } = state;
  return {
    history
  }
})(App);
